import Reveal from "../Reveal";
import SectionHeading from "../SectionHeading";
import Icon from "../Icon";
import { WHY } from "../../data/content";

export function WhyGrid() {
  return (
    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {WHY.map((w, i) => (
        <Reveal key={w.title} index={i % 3}>
          <div className="ad-card flex h-full items-start gap-4 p-7">
            <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-[#1677FF]/10 text-[#1677FF]">
              <Icon name={w.icon} className="h-5 w-5" />
            </span>
            <div>
              <h3 className="text-base font-bold text-[#111827]">{w.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#4B5563]">{w.desc}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  );
}

export default function WhySection() {
  return (
    <section className="ad-section bg-white" data-testid="why-section">
      <div className="ad-container">
        <SectionHeading
          eyebrow="Why All Data Tech"
          title={<>A technology partner built <span className="text-gradient">around outcomes.</span></>}
        />
        <div className="mt-14"><WhyGrid /></div>
      </div>
    </section>
  );
}
